export default __webpack_public_path__ + "static/media/google-authenticator-app.df1bb8a8.svg";